import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
export default class MenuOrientation extends BaseOption {
  static userInterfaceComponent = {
    label: "label",
    useCustomLabel: true,
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          value: "horizontal",
          label: "Horizontal",
        },
        {
          value: "vertical",
          label: "Vertical",
        },
      ],
    },
  };

  static defaultValue = "horizontal";

  static convertConfigValueToCompiledValue(configValue) {
    if (typeof configValue === "string") {
      return configValue;
    }
    if (configValue && configValue.value) {
      return configValue.value;
    }
  }
}
